import {
  Box,
  Button,
  Card,
  CircularProgress,
  createTheme,
  Divider,
  Grid,
  TextField,
  ThemeProvider,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Content from "../Components/Content";
import { useDateUtils } from "../../../utils/formatTime";
import RevenueCards from "../CenterAdminDashboard/NewRevenueCards";
import DataCards from "./DataCards";

import UpcommingEvents from "../Components/UpcommingEvents";
import NewCardcomp from "../../../components/card/NewCardcomp";
import LeadCalandar from "../../LeadConversation/LeadCalandar";
import MonthlyRevenuPichart from "../CenterAdminDashboard/MonthlyRevenuPichart";
import { useGetTokenOrLogout } from "../../../utils/token";
import LeadToEnrol from "./LeadToEnrol";
import AdvisorNewTarget from "./AdvisorNewTarget";
import DisplayCurrentDateTime from "../Components/DisplayCurrentDateTime";
import CustomThemeDashboard from "../Components/CustomThemeDashboard";
import MonthlyAdvisorRevenuePiechart from "./MonthlyAdvisorRevenuePiechart";
import FilterButtonComp from "../Components/FilterButtonComp";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import CustomPopup from "../../../components/CustomPopup";
import NewEnquiryComp from "../popupComponent/NewEnquiryComp";
import TaskDetails from "../../../newTestPrep/pages/AdvisorTaskWiseReport/TaskDetails";
import EnrollDetails from "../popupComponent/EnrollDetails";
import DemoDetails from "../../../newTestPrep/pages/AdvisorTaskWiseReport/DemoDetails";
import LoaderComp from "../../../newTestPrep/newComponent/LoaderComp/Loader";
import { useNavigate } from "react-router-dom";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function AdvisorNewDashBoard() {
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");
     const countryId  =localStorage.getItem("employeeCountry")
  const navigate = useNavigate();
  const getTokenOrLogout = useGetTokenOrLogout();
  const [selectedFilter, setSelectedFilter] = useState("currentmonth");
  const { currentMonthName, lastMonthName, weekRange } = useDateUtils();
  const [revenueLoading, setRevenueLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [dailyData, setDailyData] = useState({});
  const [upcommigevent, setUpcommingEvent] = useState([]);
  const [upcommingLoading, setUpcommingLoding] = useState(false);
  const [isPieChartLoading, setIsPieChartLoading] = useState(false);
  const [pieChartData, setPieChartData] = useState({});
  const [chosenDate, setChosenDate] = useState(new Date());
  const [targetData, setTargetData] = useState({});
  const [targetLoading, setTargetLoading] = useState(false);
  const [chosenDate1, setChosenDate1] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [leadData, setLeadData] = useState([]);
  const [opendetailPopup, setOpenDetailPopup] = useState(false);
  const [selectedCardName, setSelectedCardName] = useState("");

  const [SelectedCardData, setSelectedCardData] = useState([]);
  const [selectedcardFilter, setSelectedcardfilter] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleClickFilter = (criteria, cardFilter) => {
    setSelectedFilter(criteria);

    if (criteria !== "custom") {
      handleApplyRevenuFilter(criteria, null, null);

      setFromDate(null);
      setToDate(null);
    }
    if (criteria === "custom" && fromDate !== null && toDate !== null) {
      handleApplyRevenuFilter(criteria, fromDate, toDate);
    }
  };

  const handleDateChange = (date) => {
    setChosenDate(date);

    // getPieChartData(date)
  };

  // Fetch Upcomming Event
  useEffect(() => {
    setUpcommingLoding(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/ongoing-upcomingevent/${userId}`,
          { headers }
        );
        if (response.ok) {
          const data = await response.json();
          setUpcommingEvent(data);
          setUpcommingLoding(false);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
          setUpcommingLoding(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setUpcommingLoding(false);
      }
    };

    fetchData();
  }, []);

  // Fetch Target Data
  useEffect(() => {
    setTargetLoading(true);
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}advisor-rev-target/getadvtargetandcollectedrevenue/${userId}`
        );
        if (response.ok) {
          const data = await response.json();
          console.log("data", data);
          setTargetData(data);
          setTargetLoading(false);
        } else if (response.status === 401) {
          navigate("/page401");
        } else if (response.status === 403) {
          navigate("/login");
        } else {
          navigate("/page500");
        }
      } catch (error) {
        navigate("/page500");
      }
    };

    fetchData();
  }, []);

  const handleApplyRevenuFilter = async (criteria, fromDate, toDate) => {
    setRevenueLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      user_id: parseInt(userId),

      filter: criteria,
      to_date: toDate || null,
      from_date: fromDate || null,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}advisordashboard/chip-data`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();

        setDailyData(result);

        setRevenueLoading(false);
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/login");
      } else {
        navigate("/page500");
      }
    } catch (error) {
      navigate("/page500");
    }
  };

  useEffect(() => {
    if (selectedFilter !== "custom") {
      handleApplyRevenuFilter(selectedFilter);
    }
  }, []);

  // PiechartData
  const getPieChartData = async (date) => {
    setIsPieChartLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      user_id: userId,
      date: date,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}advisordashboard/contribution`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      if (response.ok) {
        const data = await response.json();
        setPieChartData(data);
        setIsPieChartLoading(false);
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/login");
      } else {
        navigate("/page500");
      }
    } catch (error) {
      navigate("/page500");
    }
  };

  useEffect(() => {
    getPieChartData(chosenDate);
  }, [chosenDate]);

  const handleDateChange1 = (date) => {
    setChosenDate1(date);

    // getPieChartData(date)
  };

  // PiechartData
  const getLeadConversionData = async (date) => {
    setLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      user_id: userId,
      date: date,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}advisordashboard/lead-conversion`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      if (response.ok) {
        const data = await response.json();
        setLeadData(data);

        setLoading(false);
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/login");
      } else {
        navigate("/page500");
      }
    } catch (error) {
      navigate("/page500");
    }
  };

  useEffect(() => {
    getLeadConversionData(chosenDate1);
  }, [chosenDate1]);

  // detailPopup
  const handleOpenDetailPopup = (cardName, cardFilter) => {
    console.log("clicked");
    setOpenDetailPopup(true);
    setSelectedCardName(cardName);
    setSelectedcardfilter(cardFilter);
  };

  const handleCloseDetailPopup = () => {
    setOpenDetailPopup(false);
  };

  const getCardMoreInfo = async (cardName, cardFilter) => {
    setDetailsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const requestData = {
      user_id: parseInt(userId),
      filter: selectedFilter,
      to_date: toDate,
      from_date: fromDate,
      filter_type: cardFilter,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}advisordashboard/fetch-chip-detailed-data`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      const result = await response.json();
      if (response.ok) {
        setSelectedCardData(result);
        setDetailsLoading(false);
        handleOpenDetailPopup(cardName, cardFilter);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setDetailsLoading(false);
      } else if (response.status === 401) {
        showSnackbar("Unknown User", "error");
        setDetailsLoading(false);
      } else if (response.status === 403) {
        showSnackbar("Unathorized User", "error");
        setDetailsLoading(false);
      } else {
        console.log("Error");
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {
      console.log(error, "Error");
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };
  return (
    <>
      <LoaderComp isLoading={detailsLoading} />
      <Grid container spacing={3}>
        <Grid item xs={12} lg={9} sm={12} md={9}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Content />
            </Grid>

            {/* Filter Button */}
            <Grid item xs={12} sm={12} mt={2}>
              <FilterButtonComp
                selectedFilter={selectedFilter}
                handleClickFilter={handleClickFilter}
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
              />
            </Grid>

            <Grid item xs={12} container spacing={2} gap={{ xs: 1, xl: 3 }}>
              <Grid item xs={12} sm={3.5} lg={2.9} xl={2.8}>
                <DataCards
                  backGround="#D5F6E1"
                  title="New Enquiries"
                  iconSrc="/Group 1000002878.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      dailyData?.new_enquiry || 0
                    )
                  }
                  onClick={() => getCardMoreInfo("New Enquiry", "new_enquiry")}
                />
              </Grid>

              <Grid item xs={12} sm={3.5} lg={2.9} xl={2.8}>
                <DataCards
                  backGround="#E7F3FF"
                  title="Demos Scheduled"
                  iconSrc="/Group 1000002854.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      dailyData?.demo_scheduled || 0
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("Demos Scheduled", "demo_scheduled")
                  }
                />
              </Grid>

              <Grid item xs={12} sm={3.7} lg={2.9} xl={2.8}>
                <DataCards
                  backGround="#FFEDFB"
                  title="Enrolled Students"
                  iconSrc="/Group 1000002879.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      dailyData?.enrolled_student
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("Enrolled Students", "enrolled_student")
                  }
                />
              </Grid>

              <Grid item xs={12} sm={3.5} lg={2.9} xl={2.8}>
                <DataCards
                  backGround="#FFF6E2"
                  title="Tasks Assigned"
                  iconSrc="/Group 1000002880.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      dailyData?.assigned_task || 0
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("Tasks Assigned", "assigned_task")
                  }
                />
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <NewCardcomp height="440px">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={5.8} lg={5.8}>
                    <LeadToEnrol
                      handleDateChange1={handleDateChange1}
                      leadData={leadData}
                      loading={loading}
                      chosenDate={chosenDate1}
                    />
                  </Grid>
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ ml: 2 }} // Add margin for spacing
                  />
                  <Grid item xs={12} sm={5.8} lg={5.8}>
                    <AdvisorNewTarget
                      loading={targetLoading}
                      targetData={targetData}
                      countryId={parseInt(countryId)}
                    />
                  </Grid>
                </Grid>
              </NewCardcomp>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} lg={3} sm={12} md={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DisplayCurrentDateTime />
            </Grid>
            <Grid item xs={12}>
              <UpcommingEvents
                data={upcommigevent}
                loading={upcommingLoading}
              />
            </Grid>

            <Grid item xs={12}>
              <NewCardcomp height="300px">
                <Typography
                  variant="h5"
                  sx={{
                    textAlign: "center",
                  }}
                >
                  {" "}
                  Contribution to Branch Revenue
                </Typography>
                <Box mt={1}>
                  <LeadCalandar onDateChange={handleDateChange} />
                  {isPieChartLoading ? (
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      mt={2}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <MonthlyAdvisorRevenuePiechart
                      loading={isPieChartLoading}
                      pieChartData={pieChartData}
                    />
                  )}
                </Box>
              </NewCardcomp>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={opendetailPopup}
        onClose={handleCloseDetailPopup}
        component={
          selectedcardFilter === "new_enquiry" ? (
            <NewEnquiryComp
              onClose={handleCloseDetailPopup}
              SelectedData={SelectedCardData}
              selectedFilter={selectedFilter}
              fromDate={fromDate}
              toDate={toDate}
            />
          ) : selectedcardFilter === "assigned_task" ? (
            <TaskDetails
              onClose={handleCloseDetailPopup}
              SelectedData={SelectedCardData}
              selectedFilter={selectedFilter}
              fromDate={fromDate}
              toDate={toDate}
            />
          ) : selectedcardFilter === "enrolled_student" ? (
            <EnrollDetails
              onClose={handleCloseDetailPopup}
              SelectedCardData={SelectedCardData}
              selectedFilter={selectedFilter}
              fromDate={fromDate}
              toDate={toDate}
            />
          ) : (
            <DemoDetails
              onClose={handleCloseDetailPopup}
              SelectedData={SelectedCardData}
              selectedFilter={selectedFilter}
              fromDate={fromDate}
              toDate={toDate}
            />
          )
        }
        title={`${selectedCardName} Details`}
        maxWidth="lg"
        showDivider={true}
      />
    </>
  );
}
